import React, { FC, ReactElement, useEffect } from 'react'
import { Alert, get } from '@ally/metronome-ui'
import styled from 'styled-components'
import { useAriaLive } from '@ally/use-aria-live'

const StyledAlert = styled(Alert)`
  max-width: 400px;
  margin: ${get.space('xl')} auto 0;
  & span {
    font-weight: bold !important;
  }
`

export const Error: FC<{ errorMessage: ReactElement | string }> = ({
  errorMessage,
}) => {
  const { announceAssertive } = useAriaLive()
  useEffect(() => {
    announceAssertive(errorMessage)
  }, [errorMessage, announceAssertive])

  return <StyledAlert variant="error" disableContainer heading={errorMessage} />
}
